// extracted by mini-css-extract-plugin
module.exports = {"main":"Label_main__nKdCt","withClick":"Label_withClick__3Bg4x","tip":"Label_tip__3pfqi","checkbox":"Label_checkbox__eE9tT","button":"Label_button__2g25H"};